<template>
  <div class="mt-4">
    <div class="checkboxItem  mt-2" v-for="(item , i ) in items" :id="item.id" :key="i"
         @click="setCheckbox(item.id)" style="cursor: pointer"
         :class="checkboxSelected.find(key => key  === item.id) && 'activeOption'"
    >
      <div class="d-flex  flex-grow-1" style="width: 100%">
        <div>
          <v-checkbox
              @click="setCheckbox(item.id)"
              v-model="checkboxSelected"
              :value="item.id"
              hide-details
              style="margin-top: -6px"
              color="primary"
          ></v-checkbox>
        </div>
        <div class="mx-2  text-right" >
          <template v-if="$vuetify.rtl">
            {{ item.text }}
          </template>
          <template v-else>
            {{ item.en_text }}
          </template>
        </div>
      </div>
    </div>
    <v-btn class="confirmBtn" id="confirm_btn" color="#3CBE8B" elevation="0" block @click="changes"
           v-if="$vuetify.breakpoint.lgAndUp">
      {{ $t('matchMaking.buttons.submit') }}
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    items: Array,
    language: {
      default: 'fa'
    },
    callChangeInOption: Boolean,
    initialAnswers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      checkboxSelected: [],
    }
  },
  mounted() {
    this.applyInitialAnswers()
  },
  methods: {
    applyInitialAnswers() {
      if (!this.initialAnswers?.length) {
        return
      }
      this.checkboxSelected = this.initialAnswers
          .map((answer) => answer.question_option_id)
          .filter((id) => id != null)
    },
    setCheckbox(id) {
      if (this.checkboxSelected.find(item => item === id)) {
        let index = this.checkboxSelected.findIndex(item => item == id)
        this.checkboxSelected.splice(index, 1)
      } else {
        this.checkboxSelected.push(id)
      }
    },
    changes() {
      this.$emit('answerHandler', this.checkboxSelected.map((item) => {
        return {
          'question_option_id': item,
        }
      }))
    },
  },
  watch: {
    initialAnswers: {
      handler() {
        this.applyInitialAnswers()
      },
      deep: true,
    },
    callChangeInOption(val) {
      if (val) {
        this.changes()
      }
    }
  }

}
</script>

<style scoped>
.markArea {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: 20px;
  height: 20px;
  border-radius: 5px;
  border: solid 1px rgb(60, 190, 139);
  background-color: rgba(209, 220, 255, 0.1);
}


.checkboxItem {
  font-size: 14px;
  transition: all 0.3s;
  display: flex;
  height: 60px;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  border-radius: 8px;
  border: 2px solid transparent;
  box-shadow: inset 0 0 0 1px #E1E1E1;
  background: #FFF;
  transition: all 0.3s;
  cursor: pointer;
  margin-bottom: 13px;
}

.checkboxItem .active {
  width: 15px;
  height: 15px;
  border-radius: 5px;
  background-color: rgb(60, 190, 139);
  margin: 0px auto;
}

.activeText {
  color: rgb(60, 190, 139);
  transition: all 0.3s;
}

.checkboxItem:hover {
  transition: all 0.3s;
  border-color: #39C990 !important;
  //background: linear-gradient(180deg, #FFF 0%, rgba(215, 244, 233, 0.80) 100%) !important;
}

.activeOption {
  border: 2px solid #39C990;
  box-shadow: none;
  //background: linear-gradient(180deg, #FFF 0%, rgba(215, 244, 233, 0.80) 100%) !important;
}

</style>
